module.exports = __webpack_public_path__ + "static/media/logo-56x62.e5c3c15a.svg";